const _excluded = ["textFieldRef"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useRef, useState } from 'react';
import { getTheme, mergeStyleSets } from '@uifabric/styling';
import { FocusZoneDirection, Layer } from 'office-ui-fabric-react';
import OutsideClickHandler from 'react-outside-click-handler';
import { compare } from 'buzz_lib_shared';
import { ActionButton } from '../../Button/Action';
import { clearIconButtonStyles } from '../../ClearIconButtonStyles';
import { FocusZone } from '../../FocusZone';
import { List } from '../../List';
import { Stack } from '../../Stack';
import { ElevatedStack } from '../../Stack/ElevatedStack';
import { TextField } from '../../TextField';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SearchDropdown = _ref => {
  var _wrapperRef$current, _wrapperRef$current2, _wrapperRef$current3;
  let {
      textFieldRef = useRef(null)
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [isListOpen, setIsListOpen] = useState(false);
  const [textFieldValue, setTextFieldValue] = useState('');
  const [isClearBtnClicked, setIsClearBtnClicked] = useState(false);
  const formatValueUsingRenderMethods = candidate => {
    return props.renderInput ? props.renderInput(candidate) : props.renderData(candidate);
  };
  const handleOutsideClick = () => {
    setIsListOpen(false);
    const foundElement = props.optionList.find(item => formatValueUsingRenderMethods(item) === textFieldValue);
    if (foundElement && !compare(foundElement, props.value)) {
      props.onChange(foundElement);
      setIsListOpen(false);
      return;
    }
    setTextFieldValue(formatValueUsingRenderMethods(props.value));
  };
  useEffect(() => {
    const userInputValue = formatValueUsingRenderMethods(props.value);
    setTextFieldValue(userInputValue);
    setIsListOpen(false);
  }, [props.value]);
  useEffect(() => {
    var _textFieldRef$current;
    if (props.shouldFocusOnRender) (_textFieldRef$current = textFieldRef.current) === null || _textFieldRef$current === void 0 || _textFieldRef$current.focus();
  }, []);
  const filterList = query => {
    const filtered = props.customSearch ? props.customSearch(query) : props.optionList.filter(s => props.renderData(s).toLowerCase().startsWith(query.toLowerCase()));
    if (props.sortStrategy) {
      return [...filtered].sort(props.sortStrategy);
    }
    if (props.sortOrder === 'asc') {
      return [...filtered].sort((a, b) => props.renderData(a).localeCompare(props.renderData(b)));
    } else if (props.sortOrder === 'desc') {
      return [...filtered].sort((a, b) => props.renderData(b).localeCompare(props.renderData(a)));
    }
    return filtered;
  };
  const [filteredItems, setFilteredItems] = useState(filterList(props.renderData(props.value)));
  useEffect(() => {
    setFilteredItems(filterList(textFieldValue));
  }, [textFieldValue]);
  const rowHeight = 41;
  const listHeight = props.maxItemsOverlay && filteredItems.length > props.maxItemsOverlay ? props.maxItemsOverlay * rowHeight : filteredItems.length * rowHeight;
  const shouldListBePositionedOnTop = props.optionListPosition === 'top';
  const wrapperRef = useRef(null);
  const listWrapperStyles = {
    root: {
      fontFamily: getTheme().fonts.medium.fontFamily,
      fontSize: 14,
      position: 'absolute',
      width: (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.getBoundingClientRect().width,
      zIndex: 2,
      boxShadow: getTheme().effects.elevation8,
      borderRadius: 3,
      overflowY: 'auto',
      marginTop: 2,
      height: listHeight,
      top: (_wrapperRef$current2 = wrapperRef.current) === null || _wrapperRef$current2 === void 0 ? void 0 : _wrapperRef$current2.getBoundingClientRect().bottom,
      left: (_wrapperRef$current3 = wrapperRef.current) === null || _wrapperRef$current3 === void 0 ? void 0 : _wrapperRef$current3.getBoundingClientRect().left
    }
  };
  const handleInputChange = (_event, value) => {
    setIsListOpen(true);
    setTextFieldValue(value || '');
  };
  const handlePicked = value => {
    var _textFieldRef$current2;
    setTextFieldValue(formatValueUsingRenderMethods(value));
    (_textFieldRef$current2 = textFieldRef.current) === null || _textFieldRef$current2 === void 0 || _textFieldRef$current2.focus();
    props.onChange(value);
    setIsListOpen(false);
  };
  const handleInputFocus = () => {
    setFilteredItems(filterList(textFieldValue));
  };
  const handleInputClick = () => {
    setFilteredItems(filterList(textFieldValue));
    setIsListOpen(true);
  };
  const handleInputBlur = () => {
    if (isClearBtnClicked) return;
    const foundElement = props.optionList.find(item => formatValueUsingRenderMethods(item) === textFieldValue);
    if (!isListOpen && foundElement && !compare(foundElement, props.value)) {
      props.onChange(foundElement);
      setIsListOpen(false);
      return;
    }
    if (!isListOpen || !filteredItems.length) setTextFieldValue(formatValueUsingRenderMethods(props.value));
  };
  const actionButtonStyles = {
    root: {
      height: 30,
      maxHeight: 30
    },
    icon: {
      fontSize: 12
    }
  };
  const ClearButton = /*#__PURE__*/_jsx(ActionButton, {
    disabled: props.disabled,
    iconProps: {
      iconName: 'Cancel'
    },
    styles: clearIconButtonStyles,
    "data-is-focusable": false,
    onClick: () => {
      props.onChange(undefined);
      setTextFieldValue('');
      setIsClearBtnClicked(false);
    },
    onMouseDown: () => setIsClearBtnClicked(true)
  });
  const DropButton = /*#__PURE__*/_jsx(ActionButton, {
    disabled: props.disabled,
    iconProps: {
      iconName: 'ChevronDown'
    },
    styles: actionButtonStyles,
    onClick: () => {
      var _textFieldRef$current3;
      (_textFieldRef$current3 = textFieldRef.current) === null || _textFieldRef$current3 === void 0 || _textFieldRef$current3.focus();
      handleInputClick();
    },
    "data-is-focusable": false
  });
  const PickButton = /*#__PURE__*/_jsx(ActionButton, {
    disabled: props.disabled,
    iconProps: {
      iconName: 'ChevronUp'
    },
    styles: actionButtonStyles,
    "data-is-focusable": false,
    onClick: () => {
      setIsListOpen(false);
    }
  });
  const renderListItem = (item, index) => {
    const itemStyles = {
      root: {
        cursor: 'pointer',
        justifyContent: 'center',
        padding: 7,
        height: rowHeight,
        selectors: {
          ':hover': {
            backgroundColor: getTheme().palette.neutralLighter
          },
          ':focus': {
            backgroundColor: getTheme().palette.neutralLighter,
            outline: 'none'
          }
        }
      }
    };
    return /*#__PURE__*/_jsx(Stack, {
      styles: itemStyles,
      "data-is-focusable": true,
      "data-title": props.renderData(item),
      "data-id": props.dataIdLookup && props.dataIdLookup(item),
      onMouseDown: () => {
        handlePicked(item);
      },
      onKeyDown: e => handleListItemSpecialKeys(e, item),
      children: props.renderData(item)
    }, index);
  };
  const closeListWitInputFocus = () => {
    var _textFieldRef$current4;
    setIsListOpen(false);
    (_textFieldRef$current4 = textFieldRef.current) === null || _textFieldRef$current4 === void 0 || _textFieldRef$current4.focus();
  };
  const handleSpecialKeys = event => {
    var _textFieldRef$current5;
    switch (event.key) {
      case 'Escape':
        event.stopPropagation();
        if (props.value === undefined) {
          setTextFieldValue('');
        } else {
          setTextFieldValue(formatValueUsingRenderMethods(props.value));
        }
        isListOpen ? closeListWitInputFocus() : (_textFieldRef$current5 = textFieldRef.current) === null || _textFieldRef$current5 === void 0 ? void 0 : _textFieldRef$current5.blur();
        return event;
      case 'Enter':
        event.stopPropagation();
        setIsListOpen(true);
        if (props.onEnterKeyDown) props.onEnterKeyDown();
        return event;
      case 'ArrowDown':
      case 'ArrowUp':
        !isListOpen && setIsListOpen(true);
        return event;
      case 'Tab':
        isListOpen && setIsListOpen(false);
        return event;
      default:
        return event;
    }
  };
  const handleListItemSpecialKeys = (event, item) => {
    switch (event.key) {
      case 'Escape':
        event.stopPropagation();
        closeListWitInputFocus();
        return event;
      case 'Enter':
        event.stopPropagation();
        handlePicked(item);
        return event;
      case 'Tab':
        setIsListOpen(false);
        return event;
      default:
        return event;
    }
  };
  const getTextFieldButton = () => props.value ? ClearButton : isListOpen ? PickButton : DropButton;
  const DropdownList = isListOpen ? /*#__PURE__*/_jsx(Layer, {
    children: /*#__PURE__*/_jsx(ElevatedStack, {
      styles: listWrapperStyles,
      "data-is-scrollable": true,
      "data-id": "".concat(props.dataId, "-dropdown-list"),
      children: /*#__PURE__*/_jsx(List, {
        items: filteredItems,
        onRenderCell: renderListItem
      })
    })
  }) : null;
  const defaultTextFieldStyles = {
    suffix: {
      backgroundColor: 'transparent',
      padding: 0
    },
    root: {
      width: '100%'
    }
  };
  return /*#__PURE__*/_jsx(OutsideClickHandler, {
    onOutsideClick: handleOutsideClick,
    children: /*#__PURE__*/_jsx(Stack, {
      styles: {
        root: {
          display: 'block',
          position: 'relative'
        }
      },
      children: /*#__PURE__*/_jsx("div", {
        ref: el => wrapperRef.current = el,
        children: /*#__PURE__*/_jsxs(FocusZone, {
          isCircularNavigation: true,
          direction: FocusZoneDirection.vertical,
          children: [shouldListBePositionedOnTop && DropdownList, /*#__PURE__*/_jsx(TextField, {
            disabled: props.disabled,
            styles: mergeStyleSets(defaultTextFieldStyles, props.styles),
            onRenderSuffix: getTextFieldButton,
            onKeyDown: handleSpecialKeys,
            onClick: handleInputClick,
            onFocus: handleInputFocus,
            placeholder: props.placeholder,
            onChange: handleInputChange,
            autoComplete: 'off',
            value: textFieldValue,
            id: props.id,
            componentRef: textFieldRef,
            onBlur: handleInputBlur,
            "data-id": props.dataId,
            label: props.label,
            required: props.required
          }), !shouldListBePositionedOnTop && DropdownList]
        })
      })
    })
  });
};
SearchDropdown.displayName = 'SearchDropdown';
SearchDropdown.defaultProps = {
  maxItemsOverlay: 5,
  optionListPosition: 'bottom',
  sortOrder: 'default'
};